export enum AccountGroupType {
  Demo = 1,
  Live = 2,
  Welcome = 3,
}

export const isAccountGroupDemo = (accountGroupTypeId: number): boolean =>
  accountGroupTypeId === AccountGroupType.Demo

export const isAccountGroupLive = (accountGroupTypeId: number): boolean =>
  accountGroupTypeId === AccountGroupType.Live

export const isAccountGroupWelcome = (accountGroupTypeId: number): boolean =>
  accountGroupTypeId === AccountGroupType.Welcome
